import React, { useState, useEffect } from 'react';
import PageTop from './Components/PageTop';
import {themsField} from '@/config/config';

const App = () => {
  const [curTheme, setCurTheme] = useState<any>('light');
  useEffect(() => {
    setCurTheme(localStorage.getItem(themsField) ? localStorage.getItem(themsField) : 'light')
  }, []);

  return (
    <div className={curTheme}>
      <PageTop setCurTheme={(t: any) => setCurTheme(t)} />
    </div>
  );
}

export default App;